import React, { FC, ReactNode } from 'react';
import { useReportStyles } from '../../report.styles';
import { useGetScalingSize } from '../../report-style.helpers';

/** One 16:9 page per print sheet. `@page` and the sheet box share the same size. */
export const ReportPrintWrapper: FC<{ children: ReactNode[] }> = ({
  children,
}) => {
  const getScalingSize = useGetScalingSize();
  const { classes } = useReportStyles({ getScalingSize });

  return (
    <div className={classes.reportPrintWrapper}>
      {children.map((page, index) => (
        <div
          key={index}
          data-report-print-sheet
          className={classes.reportPrintSheet}
        >
          {page}
        </div>
      ))}
    </div>
  );
};
